import { HUBSPOT_PORTAL_ID } from "./hubspot"

// invyナレッジベース（HubSpotナレッジベース）の公開情報
const KB_GROUP_ID = '196285482136'
const SEARCH_API_ENDPOINT = 'https://api.hubapi.com/contentsearch/v2/search'

// 記事URLの許可プレフィックス
const KNOWLEDGE_ARTICLE_URL_PREFIX = 'https://www.creativehope.co.jp/invyknowledge/'
// 検索用APIのインデックスが移転前のドメインのまま記事URLを返すため、読み替えて開く
const LEGACY_KNOWLEDGE_ARTICLE_URL_PREFIX = 'https://s.creativehope.co.jp/invyknowledge/'
const SEARCH_RESULTS_PAGE = `${KNOWLEDGE_ARTICLE_URL_PREFIX}kb-search-results`

export const KNOWLEDGE_SUGGEST_LIMIT = 5
export const KNOWLEDGE_SEARCH_MIN_LENGTH = 2
export const KNOWLEDGE_SEARCH_DEBOUNCE_MS = 500

// サジェスト取得用のAPI URL
export const buildKnowledgeSearchUrl = (term: string): string => {
  const params = new URLSearchParams({
    portalId: HUBSPOT_PORTAL_ID,
    term,
    type: 'KNOWLEDGE_ARTICLE',
    groupId: KB_GROUP_ID,
    limit: String(KNOWLEDGE_SUGGEST_LIMIT),
  })
  return `${SEARCH_API_ENDPOINT}?${params.toString()}`
}

// ナレッジベース検索結果ページのURL（Enter 押下時に新規タブで開く）
export const buildKnowledgeSearchResultsPageUrl = (term: string): string => {
  const params = new URLSearchParams({
    q: term,
    type: 'KNOWLEDGE_ARTICLE',
    groupId: KB_GROUP_ID,
  })
  return `${SEARCH_RESULTS_PAGE}?${params.toString()}`
}

// ナレッジベース配下の記事URLを開けるURLに変換する
export const toKnowledgeArticleUrl = (url: string): string | null => {
  if (url.startsWith(KNOWLEDGE_ARTICLE_URL_PREFIX)) return url
  if (url.startsWith(LEGACY_KNOWLEDGE_ARTICLE_URL_PREFIX)) {
    return KNOWLEDGE_ARTICLE_URL_PREFIX + url.slice(LEGACY_KNOWLEDGE_ARTICLE_URL_PREFIX.length)
  }
  return null
}

// レスポンスの title / description に混入する検索ハイライト用のタグを除去する
// 表示は必ずプレーンテキストで行い、dangerouslySetInnerHTML は使わない
export const stripHighlightTags = (html: string): string =>
  new DOMParser().parseFromString(html, 'text/html').body.textContent ?? ''
